import { render, staticRenderFns } from "./EditContext.vue?vue&type=template&id=a8b5c182&scoped=true"
import script from "./EditContext.vue?vue&type=script&lang=js"
export * from "./EditContext.vue?vue&type=script&lang=js"
import style0 from "./EditContext.vue?vue&type=style&index=0&id=a8b5c182&prod&lang=css&scoped=true"
import style1 from "./EditContext.vue?vue&type=style&index=1&id=a8b5c182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b5c182",
  null
  
)

export default component.exports